import http from './http'
import { Dialog, Toast } from 'vant'
import {
  isInApp,
  toLoginOut,
  isInPZAPP,
  pzOpenNativePage
} from '@/utils/bridge'
import router from '../router'

import {
  getChannelCode
} from '@/utils/utils.js'

/**
 * Get请求
 * @param { String } url
 * @param { Object } params
 */
export function sendGet (url, params = {}, config = {}) {
  config.headers = config.headers || {}
  config.headers.channelCode = getChannelCode()
  return http.get(url, { params, ...config, headers: { ...config.headers } }).then(response => {
    return response.data
  })
}
const writeUrl = ['/active/politeness']
/**
 *  Post 请求
 * @param { String } url
 * @param { Object } data
 */
export async function sendPost (url, data, config = {}) {
  // console.log('config2',config, url)

  // return http.post(url, data, config).then(response => {
  //   return response.data
  // })
  config.headers = config.headers || {}
  const _channelCode = getChannelCode()
  // const channelLev1 = _channelCode.substring(0, 3)
  // config.headers['mam-oc'] = channelLev1 === '001' ? _channelCode : '001'
  config.headers['mam-oc'] = _channelCode
  // 登录的时候后端放在cookie里面了 不需要前端传了
  const res = await http.post(url, data, config)
  if (res && res.data) {
    if (res.data.code) {
      switch (+res.data.code) {
        case 1008:
          const currentPath = window.location.pathname
          const isExcluded = writeUrl.some(prefix => currentPath.startsWith(prefix))
          if (!config.unCheckLogin && !isExcluded) {
            if (!isInApp()) {
              Dialog.confirm({
                title: '提示',
                message: '您的登录信息已过期，是否重新登录？',
                confirmButtonText: '去登录',
                cancelButtonText: '取消'
              }).then(() => {
                if (isInPZAPP) {
                  pzOpenNativePage({
                    page: '/login_page'
                  })
                } else {
                  router.push({
                    name: 'AccountLogin',
                    query: {
                      targetUrl: encodeURIComponent(window.location.href)
                    }
                  })
                }
              }).catch(() => {
                // on cancel
              })
            } else {
              toLoginOut({
                reason: '登录信息过期',
                pageURL: window.location.href,
                fetchURL: url,
                response: res
              })
            }
          }
          return res.data
        case 404:
          return Dialog.alert({ message: res.data.msg })
        default:
          return res.data
      }
    } else {
      return res.data
    }
  } else {
    if (!config.hideRequestToast) {
      Toast('系统繁忙，稍后重试!')
    }
    return null
  }
  // const myPromise = new Promise((resolve, reject) => {
  //   http.post(url, data, config).then(res => {
  //     resolve(res.data)
  //   }).catch(err => {
  //     reject(err)
  //   })
  // })
  // return myPromise
}
